<div class="w-full">
  <section class="px-3 md:px-6">
    <h3 id="primary-heading">{{ 'error.no_results.subtitle' | translate }}</h3>
    <p class="text-lg">{{ 'error.no_results.text' | translate }}</p>
  </section>
</div>
